/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { Grid, MenuItem } from '@mui/material';
import { SelectDropdown } from './SelectDropdown';
import { useOutletContext } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { apiUrl } from '../../utilities/apiUrl';

export const SelectViewBy = (props) => {
  const [empId] = useOutletContext();
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    fetch(apiUrl('/employee/' + empId), {
      method: 'GET',
      credentials: 'include',
    })
      .then((response) => response.json())
      .then((data) => {
        setIsAdmin(data.data.role === 'REGULAR_USER' ? false : true);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [empId]);

  return (
    <Grid item>
      {isAdmin ? (
        <SelectDropdown
          sx={{ minWidth: 250 }}
          size="small"
          label="View by"
          value={props.viewBy}
          onChange={props.handleViewChange}
          defaultValue={'all'}
        >
          <MenuItem value={'all'}>All Employees</MenuItem>
          <MenuItem value={'checkedin'}>Checked In Employees</MenuItem>
          <MenuItem value={'checkedout'}>Checked Out Employees</MenuItem>{' '}
          {/* <MenuItem value={"checkedin"}>Checked In Employees</MenuItem> [EPSv5_Dashboard-CheckedInEmployees]*/}
        </SelectDropdown>
      ) : (
        <SelectDropdown
          sx={{ minWidth: 250 }}
          size="small"
          label="View by"
          value={props.viewBy}
          onChange={props.handleViewChange}
          defaultValue={'checkedin'}
        >
          <MenuItem value={'checkedin'}>Checked In Employees</MenuItem>
        </SelectDropdown>
      )}
    </Grid>
  );
};
